import { Loader } from '@/shared/ui';
import { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router';
import {
  OldAppointmentManageRedirect,
  OldDviRedirect,
  OldEstimateRedirect,
  OldPayRedirect,
} from '@/features/service-request/redirect';

const BookAppointment = lazy(() => import('@/pages/BookAppointment'));
const PublicServiceRequest = lazy(() => import('@/pages/PublicServiceRequest'));
const PublicServiceRequestInspection = lazy(() => import('@/pages/PublicServiceRequestInspection'));
const PublicServiceRequestEstimate = lazy(() => import('@/pages/PublicServiceRequestEstimate'));
const PublicServiceRequestInvoice = lazy(() => import('@/pages/PublicServiceRequestInvoice'));

const ForgotPassword = lazy(() => import('@/pages/ForgotPassword'));
const ResetPassword = lazy(() => import('@/pages/ResetPassword'));
const AcceptInvitationPage = lazy(() => import('@/pages/AcceptInvitationPage'));

const NotFound = lazy(() => import('@/pages/NotFound'));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const PublicRoutes = () => (
  <Suspense fallback={<Loader />}>
    <ScrollToTop />
    <Routes>
      <Route path="/s/:token" element={<PublicServiceRequest />} />
      <Route path="/s/:token/inspection/:shareToken" element={<PublicServiceRequestInspection />} />
      <Route path="/s/:token/estimate" element={<PublicServiceRequestEstimate />} />
      <Route path="/s/:token/invoice" element={<PublicServiceRequestInvoice />} />
      {/* Legacy public links — redirected to /s/:token via the redirect-token endpoint. */}
      <Route path="/public/estimate/:repairOrderId/:token" element={<OldEstimateRedirect />} />
      <Route path="/pay/:token" element={<OldPayRedirect />} />
      <Route path="/public/dvi/:inspectionId/:shareToken" element={<OldDviRedirect />} />
      <Route path="/book/:shopId" element={<BookAppointment />} />
      <Route path="/book/:shopId/manage/:token" element={<OldAppointmentManageRedirect />} />

      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/invite/:token" element={<AcceptInvitationPage />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  </Suspense>
);
